import React from "react";

// No PageHeader - NavBar handles header globally
export default React.Fragment;
